module.exports = __webpack_public_path__ + "img/icon_6.401838b4.png";